import gql from 'graphql-tag'

export interface ITestimonial {
  id: string
  message: string
  published: boolean
  author: {
    id: number
    name: string
    avatarUrl: string
  }
  school: {
    id: number
    name: string
  }
}

export const TestimonialFieldsFragment = gql`
  fragment TestimonialFields on SchoolTestimonial {
    id
    message
    published
    author {
      id
      name
      avatarUrl
    }
    school {
      id
      name
    }
  }
`
